import { DtoBase } from "../Utils/DtoBase";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { UserLinkMember } from "./UserLinkMember";

import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";


export class UserLink extends DtoBase implements ObjectSerializer {

    public Members: List<UserLinkMember>;

	// NOT SERIALIZED
    public markedForDelete: boolean;

    constructor() {
        super();

        this.Members = new List<UserLinkMember>();

        this.markedForDelete = false;
        
    }

    get Description(): string {
		var description = "";

		for (let i = 0; i < this.Members.Count; i++) {
			if (i > 0) {
				description += " <=> ";
			}
            description += this.Members[i].Description;
		}

		return description;
    }

    get Count(): number {
        return this.Members.Count;
    }

    get Source(): UserLinkMember {
        return this.Members.Get(0);
    }

    get Target(): UserLinkMember {
        return this.Members.Get(1);
    }

    public Clear() {
        this.Members = new List<UserLinkMember>();
    }

    public AddMember(member: UserLinkMember) {
        this.Members.Add(member);
      
    }

    public GetFirstMember() {
        var member: UserLinkMember = null;
        if (this.Count > 0) {
                member = this.Members[0];
        }
    }

    public GetFirstIfEntryMember() {
        var member: UserLinkMember = null;
        if (this.HasMembers) {
            this.Members.ForEach(function (linkMember) {
                if (!linkMember.HasIfKey) {
                    return;
                }
                member = linkMember;
            });
        }
    }

    public HasMembers(): boolean {
        return (this.Count > 0);
    }


    public Write(obj: any, context: any): void {
        obj.user_link = {};
        obj = obj.user_link;

        super.Write(obj, context);

        if (this.HasMembers) {
            obj.members = [];
            ObjSerUtils.WriteObjSerCollection(obj.members, this.Members, context);
        }

    }
    
    public Read(obj: any, context: any): void {
        this.Clear();

        if (!obj.user_link) {
            throw new Error();
        }
        obj = obj.user_link;

        super.Read(obj, context);

        if (obj.members !== undefined)
            ObjSerUtils.ReadObjSerCollection(obj.members, this.Members,
                (value: any) => new UserLinkMember(), context);
    }

}